export default __webpack_public_path__ + "static/stock-6619e7854b9708398b64af2568258c9f.png";